/* eslint-disable */
export const STORE_APPLICATION = 'STORE_APPLICATION';
